import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import adminUserReducer from './adminUserReducer.js';
import userReducer from './userReducer.js';

import { thunk } from 'redux-thunk';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
  adminUser: adminUserReducer,
  user: userReducer
});

export default createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));
